import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Loader from './components/Loader';
import { ProductPdf } from './components/pdf/ProductPdf';

// Route-level code splitting: each page ships in its own chunk instead of one
// ~250 kB bundle. The eight product pages alone are 2,400–3,300 lines each, so
// this keeps the initial load small and lets react-snap prerender per route.
const Home = lazy(() => import('./pages/Home'));
const HotelManagement = lazy(() => import('./pages/HotelManagement'));
const ApartmentManagement = lazy(() => import('./pages/ApartmentManagement'));
const GovernmentHostel = lazy(() => import('./pages/GovernmentHostel'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogDetail = lazy(() => import('./pages/BlogDetail'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));
const RefundPolicy = lazy(() => import('./pages/RefundPolicy'));
const ThankYou = lazy(() => import('./pages/ThankYou'));
const Pages = lazy(() => import('./components/Pages').then((m) => ({ default: m.Pages })));
const PageDetails = lazy(() => import('./pages/PagesDetails'));
const NotFound = lazy(() => import('./components/NotFound'));
const Inventory_Index = lazy(() => import('./inventory-management-software/Inventory_Index'));
const HrmsIndex = lazy(() => import('./pages/HrmsIndex'));
const OnTheGo = lazy(() => import('./pages/OnTheGo'));
const LogisticsBilling = lazy(() => import('./pages/LogisticsBilling'));
const Hospitality = lazy(() => import('./pages/Hospitality'));
const ErpIndex = lazy(() => import('./pages/ErpIndex'));
const CrmIndex = lazy(() => import('./pages/CrmIndex'));
const AssetIndex = lazy(() => import('./pages/AssetIndex'));
const ProductsPage = lazy(() => import('./pages/ProductsPage'));
const Inventory = lazy(() => import('./pages/Inventory'));

function App() {
  return (
    <Suspense fallback={<Loader label="Loading…" />}>
      <Routes>
        <Route path="/index.html" element={<Navigate to="/" replace />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="hotel-management" element={<HotelManagement />} />
          <Route path="apartment-management" element={<ApartmentManagement />} />
          <Route path="government-hostel" element={<GovernmentHostel />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:slug" element={<BlogDetail />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="refund-policy" element={<RefundPolicy />} />
          <Route path="thank-you" element={<ThankYou />} />
          <Route path='pages' element={<Pages />} />
          <Route path="/:slug" element={<PageDetails />} />
          <Route path='inventory-index' element={<Inventory_Index />} />
          <Route path='hrms-index' element={<HrmsIndex />} />
          <Route path='on-the-go' element={<OnTheGo />} />
          <Route path='logistics-billing' element={<LogisticsBilling />} />
          <Route path='hospitality' element={<Hospitality />} />
          <Route path='erp-index' element={<ErpIndex />} />
          <Route path='crm-index' element={<CrmIndex />} />
          <Route path='asset-index' element={<AssetIndex />} />

          <Route path='product' element={<ProductsPage />} />
          <Route path='inventory' element={<Inventory />} />
           <Route path='pdf/product' element={<ProductPdf />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
